// extracted by mini-css-extract-plugin
export default {"titleContainer":"SectionTitle_titleContainer__9KUZA","title":"SectionTitle_title__dTSRB"};